@if (showAuthLangSelector) {
	<div class="fixed right-4 top-4 z-[1200] rounded-full bg-white/90 px-3 py-2 shadow-md backdrop-blur">
		<label for="auth-language-selector" class="mr-2 text-xs font-medium text-gray-700">
			{{ 'common.language.label' | transloco }}
		</label>
		<select
			id="auth-language-selector"
			class="rounded-full border border-gray-300 px-3 py-1 text-xs text-gray-700 focus:border-primary focus:outline-none"
			(change)="onLanguageChange($event)">
			@for (language of languages; track language.value) {
				<option [value]="language.value" [selected]="language.value === activeLanguage">
					{{ language.label }}
				</option>
			}
		</select>
		<button
			type="button"
			class="ml-2 rounded-full p-1 text-gray-700 hover:bg-gray-100"
			[attr.aria-label]="(themeService.theme() === 'dark' ? 'common.theme.toLight' : 'common.theme.toDark') | transloco"
			(click)="themeService.toggle()">
			<i class="pi" [class.pi-moon]="themeService.theme() === 'light'" [class.pi-sun]="themeService.theme() === 'dark'"></i>
		</button>
	</div>
}

<router-outlet></router-outlet>

<!-- Toast global para errores HTTP centralizados -->
<p-toast position="bottom-right" [breakpoints]="{'920px': {width: '100%', right: '0', left: '0'}}"></p-toast>
